import React from "react";
import { Box, Typography, createStyles, withStyles } from "@material-ui/core";
import { magicLinkColors, magicLinkRadius } from "./magicLinkTokens";

interface Props {
  title?: React.ReactNode;
  hint?: React.ReactNode;
  children?: React.ReactNode;
  classes: Record<string, string>;
}

const styles = (theme: any) =>
  createStyles({
    card: {
      display: "flex",
      flexDirection: "column",
      gap: 12,
      padding: 24,
      borderRadius: magicLinkRadius.card,
      backgroundColor: magicLinkColors.surface,
      [theme.breakpoints.down("xs")]: {
        padding: 16
      }
    },
    title: {
      fontFamily: "Nunito Sans",
      fontSize: "19px",
      fontWeight: 600,
      lineHeight: "26px",
      color: magicLinkColors.textStrong
    },
    hint: {
      fontFamily: "Nunito Sans",
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
      color: magicLinkColors.text
    }
  });

const QuestionCard = ({ title, hint, children, classes }: Props) => (
  <Box className={classes.card}>
    {title && (
      <Typography component="h2" className={classes.title}>
        {title}
      </Typography>
    )}
    {hint && <Typography className={classes.hint}>{hint}</Typography>}
    {children}
  </Box>
);

export default withStyles(styles)(QuestionCard);
